import styled from 'styled-components';
import { DeleteOutlined } from '@hangar/react-icons/core/interaction/DeleteOutlined';

const NativeTextButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    flex-shrink: 0;
    align-self: flex-start;
    margin: 0;
    border: none;
    background: none;
    cursor: pointer;
    padding: 4px;
    font-family: inherit;
    font-size: inherit;
    font-weight: 700;
    text-transform: none;
    color: ${({ theme }) => theme.tokens?.color?.text?.primary ?? '#1a1a1a'};

    &:disabled {
        color: ${({ theme }) => theme.tokens?.color?.text?.disabled ?? '#9f9f9fa3'};
        cursor: not-allowed;
    }

    &:not(:disabled):hover {
        background-color: ${({ theme }) => theme.tokens?.color?.surface?.secondary ?? 'rgba(0, 0, 0, 0.04)'};
        border-radius: ${({ theme }) => theme.tokens?.border?.radius?.sm ?? '4px'};
    }

    svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.tokens?.color?.text?.secondary ?? '#6a6a6a'};
    }
`;

export interface FlightChangesCasesClearFiltersButtonProps {
    disabled: boolean;
    onClick: () => void;
    label: string;
}

export const FlightChangesCasesClearFiltersButton = ({
    disabled,
    onClick,
    label,
}: FlightChangesCasesClearFiltersButtonProps) => (
    <NativeTextButton
        type="button"
        disabled={disabled}
        onClick={onClick}
        data-testid="flight-cases-clear-filters"
    >
        <DeleteOutlined aria-hidden />
        {label}
    </NativeTextButton>
);
